import { Component, Vue } from 'vue-property-decorator';
import { IProgressFormOpen } from './types';

@Component
export default class IsProgressFormOpenMixin extends Vue
  implements IProgressFormOpen {
  get isFormOpen(): boolean {
    return !!this.$store.state.route.meta.open;
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/isProgressFormOpen.ts